module.exports = __webpack_public_path__ + "img/start_iron_man.715d8ca5.png";